import React from 'react'
import { browserCheck } from '@ta-interaktiv/browsercheck'
import { Link } from '@ta-interaktiv/contentbricks'

export const isMobile: boolean = browserCheck.isMobile

const keyNewInfections = isMobile
  ? 'Tägliche Neuinfektionen'
  : 'Tägliche Neuinfektionen'

const keyAveInfections = isMobile
  ? 'Ø 7 Tage'
  : 'Durchschnitt (7 Tage) der täglichen Neuinfektionen'

const keyNewDeath = isMobile ? 'Tägliche Todesfälle' : 'Tägliche Todesfälle'
const keyAveDeath = isMobile
  ? 'Ø 7 Tage'
  : 'Durchschnitt (7 Tage) der täglichen Todesfälle'

const updates = { evening: 'Wird wöchentlich aktualisiert' }

const metaCases = 'Fälle'
const metaDeath = 'Tote'
export const localesCantonMultiples = {
  title: 'Bestätigte Neuinfektionen und Todesfälle in den Kantonen',
  subline: '',
  update: updates.evening,
  newInfections: keyNewInfections,
  aveInfections: keyAveInfections,
  newDeath: keyNewDeath,

  aveDeath: keyAveDeath,
  metaCases: metaCases,
  metaDeath: metaDeath,
  metaChange: isMobile ? 'Neuinf. 7 Tage' : <>Neuinf. 7 Tage</>,
  metaSum: isMobile ? 'Ø Neuinf. 7 Tage' : 'Ø Neuinf. 7 Tage',
  showMoreClosed: 'Alle Kantone anzeigen…',
  showMoreOpened: 'Zusätzliche Kantone ausblenden',
  toggleLabels: ['Sortieren nach', 'Gesamtzahl der Fälle', 'Neue Fälle 7 Tage']
}
export const localesHospitalMultiples = {
  title:
    'Covid-19-Patienten aktuell in Spitalpflege in Europa pro 100’000 Personen',
  sublineStart: (
    <>
      Die Daten stammen vom European Centre for Disease Prevention and Control
      (ECDC) und werden einmal pro Woche aktualisiert und sind jeweils einige
      Tage im Rückstand. Es stehen nur Belegungszahlen für
    </>
  ),
  sublineEnd: (
    <>
      Länder zur Verfügung. Die Daten für die Schweiz werden täglich
      aktualisiert.
    </>
  ),
  update: updates.evening,
  swissTitle: 'Total der meldenden Kantone',
  keyHosp: 'Hospitalisiert',
  keyIntensive: 'Davon auf der Intensivstation',
  metaCases: metaCases,
  showMoreClosed: 'Alle Länder anzeigen…',
  showMoreOpened: 'Zusätzliche Länder ausblenden'
}
export const localesCountryMultiples = {
  title: 'In welchen Ländern die Fälle steigen',
  subtitle: <></>,
  //Die gestrichelten Referenzlinien zeigen hypothetische Szenarien bei einer Verdoppelung der Fallzahlen in 2, 4 oder  8 Tagen.
  update: 'Wird morgens aktualisiert, nur Schweiz um 18 Uhr',
  keyCases: 'Bestätigte Fälle (kumuliert)',
  // keyCases: 'Anzahl bestätigter Fälle (kumuliert)',
  keyCurrent: 'Verdopplung aktuell in',
  keyCurrentSub: (
    <>
      <div className='numberCircle inverted'>X</div>
      <div className='label'> Tagen *</div>
    </>
  ),
  keyDoubling: isMobile
    ? 'Verdopplung nach:'
    : 'Steigung bei einer Verdopplung der Fälle nach:',
  keyDoublingSub: (
    <>
      <div className='numberCircle'>2</div>
      <div className='label'>, </div>
      <div className='numberCircle'>4</div>
      <div className='label'> oder </div>
      <div className='numberCircle'>8</div>
      <div className='label'> Tagen</div>
    </>
  ),
  newInfections: keyNewInfections,
  aveInfections: keyAveInfections,
  newDeath: keyNewDeath,
  aveDeath: keyAveDeath,
  showMoreClosed: 'Alle Länder mit mindestens 2000 Fällen anzeigen…',
  showMoreOpened: 'Zusätzliche Länder ausblenden',
  tableau: (
    <>
      Weitere Analysemöglichkeiten der Covid-19-Fallzahlen finden Sie in unserem
      externen{' '}
      <Link href='https://public.tableau.com/profile/jonas.nart#!/vizhome/COVID19_15844962693420/COVID19-TrendTracker'>
        interaktiven Dashboard
      </Link>
      .
    </>
  ),
  toggleLabels: [
    'Sortieren nach',
    'Gesamtzahl der Fälle',
    ' Steilheit des Anstiegs'
  ],
  metaCases: metaCases,
  metaDeath: metaDeath,
  metaChange: 'Neu 7 Tage'
}
export const footerText =
  "Wir verwenden für unsere Grafiken Daten aus den Kantonen, welche wir direkt von den jeweiligen Websites der Behörden oder über das <a href='https://www.web.statistik.zh.ch/covid19_dashboard/index.html#/'>Open-Data-Portal</a> des Statistischen Amtes des Kantons Zürich beziehen. Wenn die Kantone nicht melden, schauen wir beim <a href='https://covid-19-schweiz.bagapps.ch/de-1.html'>Bundesamt für Gesundheit (BAG)</a>, ob aktuelle Daten verfügbar sind. Unsere Zahl der täglichen Neuinfektionen kann von den Fallzahlen des BAGs abweichen, da es sich bei den BAG-Daten am Mittag immer auch um nachträglich gemeldete Fälle handelt. Wir empfehlen den Fokus auf den 7-Tages-Verlauf zu richten, statt auf die täglichen bestätigten Fälle, die stets nur einen vorläufigen Teil der Daten abbilden."
